export default __webpack_public_path__ + "static/media/headerImage.503300e1.webp";